import { render } from "./CategoryTag.vue?vue&type=template&id=e2663718&scoped=true"
const script = {}

import "./CategoryTag.vue?vue&type=style&index=0&id=e2663718&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2663718"]])

export default __exports__